export default __webpack_public_path__ + "static/media/filtros.67e8bf2b.svg";